var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"margin":"5px 0px"},attrs:{"dark":"","hover":"","raised":""}},[_c('v-flex',[_vm._v(_vm._s(_vm.classInfo))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }